<template>
	<div class="md-grey-page center-horizontal">
		<section class="container-white">
				Thank you for confirming your details. Your search has now been activated and we will contact you with any relevant information. </br>
				<a :href="siteUrl">{{ siteUrl }}</a>
		</section>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	props: {
		email: {
			type: Boolean,
			default: false
		},
		mobile: {
			type: Boolean,
			default: false
		}
	},
	data: function() {
		return {
			siteUrl: ""
		}
	},
	created: async function() {
		let that = this;
		let params = {
			companyId: this.$route.params.companyId,
			ownerId: this.$route.params.ownerId
		};
		if(this.email) {
			params.email = true;
		}
		if(this.mobile) {
			params.mobile = true;
		}

		await axios.patch(`${this.config.services.owners}/confirmContact`, params)
		.then(function(response) {
			console.log('ok');
		})
		.catch(function(error) {
			console.error('error:', error);
		});
		await axios.get(`${this.config.services.companies}/companySite/${this.applicant.companyId}`).then(function(response) {
			that.siteUrl = response.data ? response.data : '';
		}).catch(function(error) {
			console.error('error:', error);
		});
	},
	computed: {
	},
	methods: {
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Owner-Confirm.vue